export default "__VITE_ASSET__GElfcFA7__"